// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderInfoAviationMobileActions_wrapper__VmSpF"};